import { useEffect } from '../../lib/teact/teact';

import { getActions } from '../../global';
import { createCallbackManager } from '../../util/callbacks';
import useLastCallback from '../useLastCallback';

const blurCallbacks = createCallbackManager();
const focusCallbacks = createCallbackManager();

let isFocused = document.hasFocus();

window.addEventListener('blur', () => {
  if (!isFocused) {
    return;
  }

  isFocused = false;
  blurCallbacks.runCallbacks();
});

window.addEventListener('focus', () => {
  isFocused = true;
  focusCallbacks.runCallbacks();

  // Проверить изменения разрешений браузера на уведомления
  // Используем setTimeout чтобы вызов произошел после текущего event loop,
  // когда actions гарантированно будут загружены
  setTimeout(() => {
    try {
      const actions = getActions();
      if (actions.checkNotificationPermission) {
        actions.checkNotificationPermission();
      }
    } catch (error) {
      // Игнорируем ошибки, если actions еще не готовы
    }
  }, 0);
});

document.addEventListener('visibilitychange', () => {
  if (!document.hidden) {
    // Вкладка стала видимой - проверить разрешения
    // Используем setTimeout чтобы вызов произошел после текущего event loop,
    // когда actions гарантированно будут загружены
    setTimeout(() => {
      try {
        const actions = getActions();
        if (actions.checkNotificationPermission) {
          actions.checkNotificationPermission();
        }
      } catch (error) {
        // Игнорируем ошибки, если actions еще не готовы
      }
    }, 0);
  }
});

export default function useBackgroundMode(
  onBlur?: AnyToVoidFunction,
  onFocus?: AnyToVoidFunction,
  isDisabled = false,
) {
  const lastOnBlur = useLastCallback(onBlur);
  const lastOnFocus = useLastCallback(onFocus);

  useEffect(() => {
    if (isDisabled) {
      return undefined;
    }

    if (!isFocused) {
      lastOnBlur();
    }

    blurCallbacks.addCallback(lastOnBlur);
    focusCallbacks.addCallback(lastOnFocus);

    return () => {
      focusCallbacks.removeCallback(lastOnFocus);
      blurCallbacks.removeCallback(lastOnBlur);
    };
  }, [isDisabled, lastOnBlur, lastOnFocus]);
}

export function isBackgroundModeActive() {
  return !isFocused;
}
